
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/open-data-portals",
      function () {
        return require("private-next-pages/solutions/open-data-portals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/open-data-portals"])
      });
    }
  